import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import exesGroup from "../../assets/icons/white-exes-animated.gif";
import spanGroup from "../../assets/icons/span-group-2.gif";
import horizontalLines from "../../assets/icons/animated-horizontal-lines.gif";
import CollectibleCard, { Difficulty } from "./collectible-card";
import cardBG1 from "../../assets/images/card-bg-1.png";
import cardBG2 from "../../assets/images/card-bg-2.png";
import cardBG3 from "../../assets/images/card-bg-3.png";
import hiddenCard1 from "../../assets/images/hidden-card-1.png";
import hiddenCard2 from "../../assets/images/hidden-card-2.png";
import hiddenCard3 from "../../assets/images/hidden-card-3.png";
import { useMediaQuery } from "@mui/material";
import Slider from "react-slick";

const sxStyles = {
  mainContainer: {
    display: "flex",
    backgroundColor: "black",
    width: "100%",
    justifyContent: "center",
    flexDirection: "row",
    position: "relative",
    minHeight: "1250px",
    paddingBottom: { xs: "125px", md: "50px", lg: 0 },
  },
  content: {
    display: "flex",
    backgroundColor: "black",
    width: { xs: "300px", lg: "1440px" },
    maxWidth: "1440px",
  },
  titleIBM: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    lineHeight: { xs: "35px", md: "65px" },
    fontWeight: "700",
  },
  titleP22: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "35px", md: "64px" },
    lineHeight: { xs: "35px", md: "65px" },
    fontWeight: "700",
  },
  titleContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "center",
    marginTop: "110px",
    marginBottom: "24px",
  },
  sectionText: {
    alignSelf: "center",
    color: "white",
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: "400",
    fontFamily: "IBM Plex Sans",
    marginBottom: "85px",
    maxWidth: "600px",
  },
  cardsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "112px",
    width: "1096px",
    margin: "0 auto",
  },
};
const CardsSection = () => {
  const matches = useMediaQuery("(max-width:600px)");
  const settings = {
    infinite: false,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    speed: 500,
    easing: "easeOutQuint",
    useTransform: true,
  };
  return (
    <Stack sx={sxStyles.mainContainer}>
      <Stack sx={sxStyles.content}>
        <img
          src={exesGroup}
          style={{
            position: "absolute",
            left: "1050px",
            top: "50px",
            width: "320px",
            height: "30px",
          }}
        />
        <Stack sx={{ display: { xs: "none", md: "block" } }}>
          <img
            src={horizontalLines}
            style={{
              height: "20px",
              width: "55px",
              position: "absolute",
              top: "100px",
              left: "150px",
            }}
          />
          <img
            src={horizontalLines}
            style={{
              height: "20px",
              width: "55px",
              position: "absolute",
              top: "115px",
              left: "150px",
            }}
          />
          <img
            src={horizontalLines}
            style={{
              height: "20px",
              width: "55px",
              position: "absolute",
              top: "130px",
              left: "150px",
            }}
          />
          <img
            src={horizontalLines}
            style={{
              height: "20px",
              width: "55px",
              position: "absolute",
              top: "145px",
              left: "150px",
            }}
          />
          <img
            src={horizontalLines}
            style={{
              height: "20px",
              width: "55px",
              position: "absolute",
              top: "160px",
              left: "150px",
            }}
          />
        </Stack>
        <Grid sx={sxStyles.titleContainer}>
          <img
            src={spanGroup}
            style={{
              position: "absolute",
              left: "300px",
              height: "130px",
              width: "30px",
            }}
          />
          <Typography sx={sxStyles.titleIBM}>COLECCIONA, CANJEA, </Typography>
          <Typography sx={sxStyles.titleP22}> GANA</Typography>
        </Grid>
        <Typography sx={sxStyles.sectionText}>
          Completá cada Session y Saga con sus cards correspondientes para
          acceder a premios y beneficios únicos.
        </Typography>
        {matches ? (
          <Slider {...settings}>
            <CollectibleCard
              cardDifficulty={Difficulty.FÁCIL}
              cardImg={cardBG1}
              hiddenImg={hiddenCard1}
            />
            <CollectibleCard
              cardDifficulty={Difficulty.MEDIANAS}
              cardImg={cardBG2}
              hiddenImg={hiddenCard2}
            />
            <CollectibleCard
              cardDifficulty={Difficulty.DIFÍCILES}
              cardImg={cardBG3}
              hiddenImg={hiddenCard3}
            />
          </Slider>
        ) : (
          <Grid sx={sxStyles.cardsContainer}>
            <CollectibleCard
              cardDifficulty={Difficulty.FÁCIL}
              cardImg={cardBG1}
              hiddenImg={hiddenCard1}
            />
            <CollectibleCard
              cardDifficulty={Difficulty.MEDIANAS}
              cardImg={cardBG2}
              hiddenImg={hiddenCard2}
            />
            <CollectibleCard
              cardDifficulty={Difficulty.DIFÍCILES}
              cardImg={cardBG3}
              hiddenImg={hiddenCard3}
            />
          </Grid>
        )}
      </Stack>
    </Stack>
  );
};

export default CardsSection;
